import React, { useState, useRef } from 'react';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

import { useSelector } from 'react-redux';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import WebServicesReq from './components/WebServicesReq';
import Loading from './components/Loading';
import ProgramReq from './components/ProgramReq';

import { clearRequirements, setModuleSettingsAsyncThunk } from '../../../store/modules/moduleSlice';
import { setLoginSuccess, setLoginToken, clearBilsoftState } from '../../../store/modules/bilsoftSlice';
import { loginBilsoft } from './utils/bilsoftRequest';

export default function Bilsoft() {
    const { selectedModule, selectedProgram, selectedCompanyId, module, selectedCompany } = useSelector((state) => state.modules);
    const { webServiceReq, programReq } = useSelector((state) => state.bilsoft);

    const [loading, setLoading] = useState(false);
    const [pending, setPending] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toast = useRef(null);

    const save = async () => {
        // First, attempt bilsoft login
        try {
            const loginResponse = await loginBilsoft(programReq.taxNumber, programReq.databaseId, programReq.period, programReq.username, programReq.password, programReq.apiUsername, programReq.apiPassword);

            if (loginResponse.data.success && loginResponse.data.data.token) {
                // Login successful, save the module settings
                dispatch(setLoginSuccess(true));
                dispatch(setLoginToken(loginResponse.data.data.token));

                toast.current.show({
                    severity: 'success',
                    summary: 'Başarılı',
                    detail: 'Bilsoft girişi başarılı',
                    life: 2000
                });

                // Prepare data for module settings
                const data = {
                    companyId: selectedCompanyId,
                    moduleId: module.id,
                    settings: {
                        moduleId: module.id,
                        title: module.title,
                        program: {
                            _id: selectedProgram?.id || 'bilsoft',
                            title: selectedProgram?.title || 'Bilsoft',
                            requirements: [programReq]
                        },
                        webService: {
                            requirements: webServiceReq,
                            _id: selectedModule?.id || 'bilsoft',
                            title: selectedModule?.title || 'Bilsoft',
                            url: selectedModule?.url || ''
                        },
                        bilsoftToken: loginResponse.data.data.token,
                        bilsoftExpiration: loginResponse.data.data.expiration
                    }
                };

                setPending(true);
                let res = await dispatch(setModuleSettingsAsyncThunk(data));

                if (res.meta.requestStatus === 'fulfilled') {
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Modül Eklendi', life: 1500 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Modül Eklenemedi', life: 1500 });
                }

                setTimeout(() => {
                    setPending(false);
                    navigate(`/companies`);
                    dispatch(clearRequirements());
                    dispatch(clearBilsoftState());
                }, 500);
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Hata',
                    detail: 'Bilsoft girişi başarısız - Lütfen bilgilerinizi kontrol edin',
                    life: 3000
                });
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: error?.response?.data?.message,
                life: 3000
            });
        }
    };

    if (loading) {
        return <Loading loading={loading} onChangeLoading={() => setLoading(false)} />;
    }

    const programReqState = () => {
        return programReq?.taxNumber && programReq?.databaseId && programReq?.period && programReq?.username && programReq?.password && programReq?.apiUsername && programReq?.apiPassword;
    };

    const webServiceReqState = () => {
        return webServiceReq?.username && webServiceReq?.password;
    };

    const isDisabled = () => {
        if (programReqState() && webServiceReqState()) {
            return false;
        }

        return true;
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="flex align-items-center">
                <Button className="" icon="pi pi-building" />
                <h3 className="mb-4 ml-3">{selectedCompany?.name}</h3>
            </div>
            <div className="card">
                <div className="">
                    <div className="flex flex-column md:flex-row">
                        <div className="w-full">
                            <ProgramReq />
                        </div>

                        <div className="w-full md:w-1">
                            <Divider layout="vertical" className="hidden md:flex"></Divider>
                        </div>

                        <WebServicesReq />
                    </div>
                </div>

                {
                    <div className="text-center mt-5">
                        <Button label="Kaydet" icon="pi pi-check" className="p-button-success text-white p-mr-2 px-6" onClick={() => save()} disabled={isDisabled()} loading={pending} />
                    </div>
                }
            </div>
        </>
    );
}
